import axios from "axios";

const VITE_LIPT_BACKEND_API_URL = import.meta.env.VITE_LIPT_BACKEND_API_URL;

export const uploadFile = async (jmdsJwt:string, simulatorId: string, file: File) => {
  const formData = new FormData();
  formData.append("JMDS_JWT_FRONT", jmdsJwt);
  formData.append("uploadFiles", file);
  formData.append("simulator_id", simulatorId);
  try {
    const response = await axios.post(`${VITE_LIPT_BACKEND_API_URL}/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (response.status !== 200) {
      throw new Error('uploadFile upload is failure.');
    }
    return response.data.filename;
  } catch(error) {
    throw error;
  }
}

export const deleteFile = async (jmdsJwt:string, simulatorId: string, fileName: string) => {
  const param = {
    JMDS_JWT_FRONT: jmdsJwt,
    filename: fileName,
    simulator_id: simulatorId
  }
  try {
    const response = await axios.post(`${VITE_LIPT_BACKEND_API_URL}/fileDelete`, param, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.status !== 200) {
      throw new Error('uploadFile delete is failure.');
    }
    return response.data.filename;
  } catch(error) {
    throw error;
  }
}